// extracted by mini-css-extract-plugin
export default {"livestext":"livestext_livestext__w3vXX"};